import Link from 'next/link';
 import Icon from'@/components/ui/AppIcon';

const QuickStart = () => {
  const quickActions = [
    {
      id: 'action_study',
      title: 'Start Study Session',
      description: 'Learn with instant explanations',
      icon: 'BookOpenIcon',
      color: 'bg-primary text-primary-foreground',
      href: '/category-selection',
    },
    {
      id: 'action_test',
      title: 'Take Practice Test',
      description: 'Simulate exam conditions',
      icon: 'ClipboardDocumentCheckIcon',
      color: 'bg-accent text-accent-foreground',
      href: '/category-selection',
    },
  ]

  const achievements = [
    { id: 'ach_1', title: 'First Flight', description: 'Complete your first study session', earned: true, icon: 'RocketLaunchIcon' },
    { id: 'ach_2', title: 'Perfect Score', description: 'Score 100% on any test', earned: true, icon: 'StarIcon' },
    { id: 'ach_3', title: 'Week Streak', description: 'Study for 7 consecutive days', earned: true, icon: 'FireIcon' },
    { id: 'ach_4', title: 'Topic Master', description: 'Complete all questions in a category', earned: false, icon: 'AcademicCapIcon' },
  ]

  return (
    <div className="space-y-4 sm:space-y-6">
      {/* Quick Start */}
      <section className="bg-card rounded-2xl p-4 sm:p-6 border border-border">
        <h2 className="text-lg sm:text-xl font-bold text-foreground mb-3 sm:mb-4">Quick Start</h2>
        <div className="space-y-2 sm:space-y-3">
          {quickActions.map((action) => (
            <Link
              key={action.id}
              href={action.href}
              className={`block p-3 sm:p-4 ${action.color} rounded-xl hover:opacity-90 transition-opacity`}
            >
              <div className="flex items-center gap-2 sm:gap-3 mb-1 sm:mb-2">
                <Icon name={action.icon as any} size={20} className="sm:w-6 sm:h-6" />
                <span className="text-sm sm:text-base font-semibold">{action.title}</span>
              </div>
              <p className="text-xs sm:text-sm opacity-90">{action.description}</p>
            </Link>
          ))}
        </div>
      </section>

      {/* Achievements */}
      <section className="bg-card rounded-2xl p-4 sm:p-6 border border-border">
        <div className="flex items-center justify-between mb-3 sm:mb-4">
          <h2 className="text-lg sm:text-xl font-bold text-foreground">Achievements</h2>
          <span className="text-xs sm:text-sm font-medium text-muted-foreground">3/4</span>
        </div>
        <div className="space-y-2 sm:space-y-3">
          {achievements.map((achievement) => (
            <div
              key={achievement.id}
              className={`p-2.5 sm:p-3 rounded-xl border ${
                achievement.earned
                  ? 'border-success/30 bg-success/5' :'border-border bg-muted/50'
              }`}
            >
              <div className="flex items-center gap-2 sm:gap-3">
                <div className={`w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center ${
                  achievement.earned ? 'bg-success/20 text-success' : 'bg-muted text-muted-foreground'
                }`}>
                  <Icon name={achievement.icon as any} size={16} className="sm:w-5 sm:h-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className={`text-xs sm:text-sm font-semibold ${
                    achievement.earned ? 'text-foreground' : 'text-muted-foreground'
                  }`}>
                    {achievement.title}
                  </div>
                  <div className="text-xs text-muted-foreground truncate">{achievement.description}</div>
                </div>
                {achievement.earned && (
                  <Icon name="CheckCircleIcon" size={18} className="text-success sm:w-5 sm:h-5 flex-shrink-0" />
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default QuickStart